// extracted by mini-css-extract-plugin
export default {"recos":"i--z","productCardOverride":"j--z","rowHasBadge":"k--z"};